const RubiReportMenu = () => {
  return <div className="menu"></div>;
};

export default RubiReportMenu;
